export function bytesToHex(bytes: Uint8Array): string {
  return `0x${Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("")}`;
}

export function hexToBytes(value: string, expectedBytes?: number): Uint8Array {
  const hex = stripHexPrefix(value);
  if (hex.length % 2 !== 0 || !/^[0-9a-fA-F]*$/.test(hex)) {
    throw new Error("Invalid hex value");
  }
  if (expectedBytes !== undefined && hex.length !== expectedBytes * 2) {
    throw new Error(`Expected ${expectedBytes}-byte hex value`);
  }

  const bytes = new Uint8Array(hex.length / 2);
  for (let index = 0; index < bytes.length; index += 1) {
    bytes[index] = Number.parseInt(hex.slice(index * 2, index * 2 + 2), 16);
  }
  return bytes;
}

export function stripHexPrefix(value: string): string {
  if (!value.startsWith("0x")) {
    throw new Error("Expected 0x-prefixed hex value");
  }
  return value.slice(2);
}

export function normalizeAddress(value: string): string {
  return bytesToHex(hexToBytes(value, 20));
}

export function normalizeBytes32(value: string): string {
  return bytesToHex(hexToBytes(value, 32));
}

export function bytesToBigInt(bytes: Uint8Array): bigint {
  const hex = bytesToHex(bytes).slice(2);
  return hex.length === 0 ? 0n : BigInt(`0x${hex}`);
}

export function decimalToQuantityHex(value: bigint): string {
  return `0x${value.toString(16)}`;
}
